/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { SegmentedTabsProps } from './types';
import styles from './index.module.scss';

function SegmentedTabs({
  tabs,
  activeTabKey,
  onTabChange,
  tabItemClassName = '',
}: SegmentedTabsProps) {
  const [activeTab, setActiveTab] = useState(activeTabKey || tabs[0].key);

  useEffect(() => {
    if (activeTabKey && activeTabKey !== activeTab) {
      setActiveTab(activeTabKey);
    }
  }, [activeTab, activeTabKey, tabs]);

  const getTabItemClasses = (tab) =>
    classnames(styles.tabItem, tabItemClassName, {
      [styles.tabItem__active]: tab.key === activeTab,
      [styles.tabItem__iconRight]: tab?.iconProps?.position === 'right',
    });

  return (
    <div className={styles.segmentedTabWrapper}>
      {tabs.map((tab) => (
        <span
          key={tab.key}
          className={getTabItemClasses(tab)}
          onClick={() => {
            setActiveTab(tab.key);
            onTabChange?.(tab.key);
          }}
        >
          {tab.iconProps?.icon}
          {tab.label && <span>{tab.label}</span>}
        </span>
      ))}
    </div>
  );
}

export default SegmentedTabs;
